import { useParams, useNavigate } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import { usePeriodStore } from '@/stores/periodStore'
import { WizardLayout } from '@/components/wage-wizard/WizardLayout'
import { WizardAdjustmentsContent } from '@/components/wage-wizard/adjustments/WizardAdjustmentsContent'

export function WizardAdjustmentsStep() {
  const { periodId } = useParams<{ periodId: string }>()
  const navigate = useNavigate()
  const { currentUser } = useAuth()
  const markStepComplete = usePeriodStore(state => state.markStepComplete)

  const handleComplete = async () => {
    if (currentUser && periodId) {
      await markStepComplete(currentUser, periodId, 'adjustments')
    }
    navigate(`/periods/${periodId}/review`)
  }

  if (!periodId) {
    return null
  }

  return (
    <WizardLayout currentStep="adjustments">
      <WizardAdjustmentsContent
        periodId={periodId}
        onComplete={handleComplete}
      />
    </WizardLayout>
  )
}
